import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeNonNumeric } from "utils/helpers"
import { FormCard, MainBodyCard } from "components/Cards";
import SaveButton from "components/Button/SaveButton";
import { useModal } from "context/ModalContext";
import { SystemService } from "services/SystemService/SystemService";

export default function Tax(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchSystem, fetchUpdateSystem } = SystemService()
    
    const [tax, setTax] = useState('')

    // Button Event
    const saveBtnClick = async () => {
        if (tax === '') {
            showFail('Tax is required!')
            return false
        }

        const onConfirm = await confirm()
        if (!onConfirm) return

        showLoading()

        try {
            const res = await fetchUpdateSystem('tax', tax, '')
            if (!res) return

            showSuccess({
                onSuccess: () => {
                    navigate("/setting") 
                }
            })
        }
        finally {
            hideLoading()
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchSystem('tax')
                if (!res) return 

                setTax(res.data.systemValue)
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    },[])

    return(
        <MainBodyCard>
            <div>
                <span className="font-semibold text-2xl">Tax</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <FormCard title='Tax'>
                    <div className="w-24 flex gap-2 items-center">
                        <input className="input" value={tax} onChange={(e) => { setTax(removeNonNumeric(e.target.value) )}} />
                        <span>%</span>
                    </div>
                </FormCard>
            </div>

            <div className="flex w-full justify-end">
                <SaveButton visible={true} onClick={saveBtnClick} />
            </div>
        </MainBodyCard>
    )
}